import clsx from 'clsx';
import { FaArrowRight, FaCheck } from "react-icons/fa6";
import { useNavigate } from "react-router-dom";

export function ProgressBar({ children }) {
	
	return (
		<div className="
			fixed 
			top-0 
			p-2 
			bg-secondary 
			w-full 
			left-0
			z-[10] 
			top-header-h 
			top-[60px] 
			h-[45px]"
		>
			<div className="max-w-[800px] mx-auto">
				<div className="
					flex 
					items-center 
					justify-between
					relative
					"
				>
					{children}
				</div>
			</div>
		</div>
	)
}

export function ProgressBarItem({ number, label, stage, url }) {
	const navigate = useNavigate();


	function goToStage() {
		if(stage !== 1) {
			navigate(url)
		}
	}
	
	return (
		<div
			onClick={goToStage}
			className={clsx(
				"border-[2px] border-grey text-grey text-center p-1",
				"relative z-[2]",
				"py-1 px-2 transition rounded-default", 
				stage >= number ? "bg-guards border-guards text-white" : "bg-secondary text-black"
			)}
		>

			<label
				className="
					hidden md:block
					 
					text-[11px]
				">
					{label}
			</label>
		</div>
	)
}

export function ProgressIndicator({stage, stages, widths}) {
	const defaultWidths = Array.from({length: stages}, (_, i) => (i / stages) * 100);
	const stageWidths = widths || defaultWidths;

	return (
		<div 
			className="
				absolute
				top-15px
				z-[1]
				h-[2px]
				w-full
			">

			{/* bg */}
			<div className="absolute inset-0 bg-grey z-[1]"></div>

			{/* indicator */}
			<div 
				className="absolute inset-0 bg-guards z-[2] transition"
				style={{
					width: `${stageWidths[stage - 1] || 0}%`
				}}
			></div>

		</div>
	)
}

export function FormStage({
	stage, 
	heading, 
	subheading, 
	children, 
	stages, 
	onSave,
	previousUrl
}) {

	const navigate = useNavigate();


	function goPrevious() {
		navigate(previousUrl);
	}

	return (
		<div
			className="
				w-full md:w-11/12
				max-w-[700px]
				mx-auto
				mt-[50px] md:mt-[70px]
			"
		>
			<h2 className="text-md md:text-lg text-grey mb-1 ">{heading}</h2>
			<h3 className="text-lg md:text-xl mb-2 md:mb-4 ">
				{stage} of {stages}: {subheading}
			</h3>
			<div 
				className="
					rounded-[20px] md:rounded-[30px]
					bg-white
					shadow-[0_0_15px_10px_rgba(0,0,0,0.06)]
					p-xs md:p-sm
				"
			>
				{children}	
			</div>

			<div className="mt-sm flex justify-between items stretch">
				
				{/* back */}
				<div>
					{stage !== 1 && (
						<FormPaginationButton
							onClick={goPrevious}
							label="Previous"
						/>
					)} 
				</div>

				{/* next */}
				<div>
					{stage !== stages ? (
						<FormPaginationButton
							onClick={onSave}
							label={"Save and continue"}
						/>
					) : (
						<button
							onClick={onSave}
							className="
								py-2 px-4
								
								bg-brg
								text-white
								flex items-center
								text-lg
								rounded-default
							"
						>
							<span>Save</span>
							<FaCheck className="ml-2" />
						</button>
					)}
				</div>

			</div>
			
		</div>
	)
}

const FormPaginationButton = ({onClick, label}) => {
	return (
		<button
			onClick={onClick}
			className="
				py-2 px-4
				
				bg-guards
				text-white
				flex items-center
				text-lg
				rounded-default
			"
		>
			{label === 'Previous' && (
				<FaArrowRight className="rotate-[180deg] mr-2" />
			)}
			<span>{label}</span>

			{(label === 'Next' || label === 'Save and continue') && (
				<FaArrowRight className="ml-2" />
			)}
		</button>
	)
}


export function ProgressBarCars({stage, id}) {
	return (
		<ProgressBar>
			<ProgressIndicator 
				stage={stage} 
				widths={[0, 30, 50, 75, 100]}
			/>
			<ProgressBarItem url={`/edit/car/${id}`} stage={stage} number="1" label="1: Required" />
			<ProgressBarItem url={`/edit/car/optional/${id}`} stage={stage} number="2" label="2: Optional" />
			<ProgressBarItem url={`/edit/car/images/${id}`} stage={stage} number="3" label="3: Images" />
			<ProgressBarItem url={`/edit/car/associations/${id}`} stage={stage} number="4" label="4: Associations" />
			<ProgressBarItem url={`/edit/car/mods/${id}`} stage={stage} number="5" label="5: Mods" />
		</ProgressBar>
	)
}

export function ProgressBarNote({stage, id}) {
	return (
		<ProgressBar>
			<ProgressIndicator 
				stage={stage} 
				widths={[0, 100]}
			/>
			<ProgressBarItem url={`/edit/note/${id}`} stage={stage} number="1" label="1: Required" />
			<ProgressBarItem url={`/edit/note/optional/${id}`} stage={stage} number="2" label="2: Optional" />
		</ProgressBar>
	)
}

export function ProgressBarResource({stage, id}) {
	return (
		<ProgressBar>
			<ProgressIndicator 
				stage={stage} 
				widths={[0, 100]}
			/>
			<ProgressBarItem url={`/edit/resource/${id}`} stage={stage} number="1" label="1: Required" />
			<ProgressBarItem url={`/edit/resource/optional/${id}`} stage={stage} number="2" label="2: Optional" />
		</ProgressBar>
	)
}